/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import DeviceModel from 'cio/models/device';
import { inject as service } from '@ember/service';
import DevicesService from 'cio/services/devices';

interface DeviceTitleArgs {
  device: DeviceModel;
  copyButtonBackground: string;
}

export default class DeviceTitle extends Component<DeviceTitleArgs> {
  @service devices!: DevicesService;

  constructor(owner: unknown, args: DeviceTitleArgs) {
    super(owner, args);

    this.devices.load.perform();
  }

  get deviceMarketingName() {
    return this.devices.getMarketingName(this.args.device.deviceModel);
  }
}
